// source: protocol_cmd.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.himpb.CMD', null, global);
/**
 * @enum {number}
 */
proto.himpb.CMD = {
  DEFAULT_CMD: 0,
  REQ_BEFORE_PROCESSING_CMD: 1,
  REQ_AFTER_PROCESSING_CMD: 2,
  SVR_CONNECT_REQ: 3,
  SVR_CONNECT_RSP: 4,
  SVR_KEEPLIVE_ECHO: 5,
  USER_MIN_CMD: 20,
  USER_KEEPLIVE_REQ: 21,
  USER_KEEPLIVE_RSP: 22,
  GET_SERVER_CURRENT_TS_REQ: 23,
  GET_SERVER_CURRENT_TS_RSP: 24,
  USER_LOGIN_REQ: 30,
  USER_LOGIN_RSP: 31,
  USER_LOGOUT_NTY: 32,
  USER_LAST_STATUS_NTY: 35,
  USER_SESSION_CTRL_NTY: 36,
  USER_LOGIN_ON_OTHER_DEVICE_NTY: 37,
  USER_TOPIC_SUBSCRIBE_NTY: 38,
  USER_TOPIC_SUBSCRIBE_RESULT_RCP: 39,
  USER_TOPIC_UNSUBSCRIBE_NTY: 40,
  USER_TOPIC_UNSUBSCRIBE_RESULT_RCP: 41,
  USER_DEVICE_TOKEN_REPORT_NTY: 42,
  USER_LAST_STATUS_BATCH_NTY: 43,
  USER_LOGIN_RECONFIRM_REQ: 44,
  USER_LOGIN_RECONFIRM_RSP: 45,
  USER_MAX_CMD: 99,
  IM_MSG_MIN_CMD: 100,
  IM_MSG_SEND_REQ: 101,
  IM_MSG_SEND_RSP: 102,
  IM_MSG_RELAY_NTY: 103,
  IM_MSG_RELAY_RCP: 104,
  IM_MSG_RECEIPT_ACK: 105,
  IM_MSG_OFFLINE_MSGS_NTY: 106,
  IM_MSG_RPC_REQ: 107,
  IM_MSG_RPC_RSP: 108,
  BATCH_IM_MSG_RELAY_RCP: 109,
  IM_MSG_MAX_CMD: 199,
  GROUP_MIN_CMD: 200,
  GROUP_CHECK_IN_REQ: 201,
  GROUP_CHECK_IN_RSP: 202,
  GROUP_LOAD_GROUPS_NTY: 203,
  GROUP_ADD_GROUP_NTY: 204,
  GROUP_DEL_GROUP_NTY: 205,
  GROUP_ADD_GROUP_MEMBERS_NTY: 206,
  GROUP_DEL_GROUP_MEMBERS_NTY: 207,
  GROUP_UPDATE_GROUP_INFO_NTY: 211,
  GROUP_MAX_CMD: 299,
  RECORD_MIN_CMD: 300,
  RECORD_SERVICE_RSP: 302,
  RECORD_MAX_CMD: 399,
  LIVING_MIN_CMD: 400,
  LIVING_START_PUSH_NTY: 401,
  LIVING_MAX_CMD: 499,
  CONF_MIN_CMD: 500,
  CONF_ROLE_REQUEST_NTY: 501,
  CONF_ROLE_REQUEST_REPLY: 502,
  CONF_MAX_CMD: 599,
  SIGNALING_MIN_CMD: 1000,
  SIGNALING_CREATE_REQ: 1001,
  SIGNALING_CREATE_RSP: 1002,
  SIGNALING_CLOSE_REQ: 1003,
  SIGNALING_CLOSE_RSP: 1004,
  SIGNALING_INVITE_REQ: 1010,
  SIGNALING_INVITE_RSP: 1011,
  SIGNALING_INVITE_RELAY_NTY: 1012,
  SIGNALING_INVITE_OFFLINE_RELAY_NTY: 1013,
  SIGNALING_INVITE_RESULT_RCP: 1014,
  SIGNALING_JOIN_REQ: 1020,
  SIGNALING_JOIN_RSP: 1021,
  SIGNALING_KEEPLIVE_REQ: 1030,
  SIGNALING_KEEPLIVE_RSP: 1031,
  SIGNALING_KEEPLIVE_NTY: 1032,
  SIGNALING_USER_CTRL_NTY: 1040,
  SIGNALING_USER_CTRL_RCP: 1041,
  SIGNALING_SESSION_STATUS_CHANGED_NTY: 1050,
  SIGNALING_MEMBER_STATUS_CHANGED_NTY: 1051,
  SIGNALING_MEMBER_STATUS_CHANGED_BATCH_NTY: 1052,
  SIGNALING_USER_JOINED_NTY: 1053,
  SIGNALING_QUERY_REQ: 1100,
  SIGNALING_QUERY_RSP: 1101,
  SIGNALING_MAX_CMD: 1999,
  MEDIA_CONTROL_REQ: 2001,
  MEDIA_CONTROL_RSP: 2002,
  MEDIA_STATUS_CHANGED_NTY: 2003,
  SYNC_USER_INFO_BATCH_NTY: 2801,
  MAX_CMD: 3000
};

goog.object.extend(exports, proto.himpb);
